export function computeFleetDriverMetric(metricKey, driversData = []) {
  const drivers = Array.isArray(driversData) ? driversData : [];
  const assignedDrivers = drivers.filter(
    (driver) =>
      driver.vehicle_id != null ||
      (driver.vehicle && driver.vehicle !== "Not Assigned"),
  ).length;

  switch (metricKey) {
    case "totalDrivers":
      return drivers.length;
    case "assignedDrivers":
      return assignedDrivers;
    case "unassignedDrivers":
      return drivers.length - assignedDrivers;
    default:
      return 0;
  }
}
